import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from 'app/app.module';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';



EnvironmentLoader.loadEnvironment().then(() => {
    if (EnvironmentLoader.environment.production) {
      enableProdMode();
    }
  
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
